export default "data:text/css;base64,LlBTUERGS2l0LVRvb2xiYXIgew0KICAgIG1pbi1oZWlnaHQ6IDY0cHggIWltcG9ydGFudDsNCiAgICBoZWlnaHQ6IDY0cHggIWltcG9ydGFudDsNCn0="